import { Injectable } from '@angular/core';
import { NavSignalsService } from '@core/services/nav.signals.service';
import { combineLatest, EMPTY, map, Observable } from 'rxjs';
import { VERSION } from '@core/version';
import { getFurtureFeatures } from './future-features';
import { getKnownIssues } from './known-issues';
import { getVersionData } from './version-details';

interface VersionData {
  appVersion: string;
  versionData: any[];
  futureFeatures: any[];
  knownIssues: any[];
  lastUpdated: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(
    private navSignalsService: NavSignalsService
  ) { }

  appVersion = VERSION;

  initializeVersionData(): Observable<VersionData> {
    console.log("%cInitializing Version Data...", "color: orange");
    const versionData = localStorage.getItem('logbook.version.data');
    if (versionData) {
      const _versionData = JSON.parse(versionData);
      if (_versionData.appVersion !== this.appVersion) {
        
        localStorage.removeItem('logbook.version.data');
        console.log("%cVersion Data Outdated, creating...", "color: orange");
        return this.createVersionData();
      }
      else {
        console.log("%cVersion Data found, updating...", "color: lightgreen");
        return this.updateVersionData();
      }
    }
    else {
      console.log("%cVersion Data not found, creating...", "color: orange");
      return this.createVersionData();
    }
  }

  createVersionData(): Observable<VersionData> {
    return combineLatest([
      getVersionData(),
      getKnownIssues(),
      getFurtureFeatures()
    ]).pipe(
      map( ([versionData, knownIssuesData, futureFeaturesData]) => {
        if(!versionData || !knownIssuesData || !futureFeaturesData) {
          console.log("%cVersion Data creation unsuccessful", "color: white; background-color: red");
          return {
            appVersion: '',
            versionData: [],
            futureFeatures: [],
            knownIssues: [],
            lastUpdated: ''
          } as VersionData;
        }
        const versionDataObj = {
          appVersion: this.appVersion,
          versionData: versionData,
          futureFeatures: futureFeaturesData,
          knownIssues: knownIssuesData,
          lastUpdated: new Date().toISOString()
        };
        localStorage.setItem('logbook.version.data', JSON.stringify(versionDataObj));
        console.log("%cVersion Data created successfully", "color: lightgreen");
        return versionDataObj;
      })
    )
  }

  updateVersionData(): Observable<VersionData> {
    const storedData = localStorage.getItem('logbook.version.data');
    if (storedData) {
      const versionStoredData = JSON.parse(storedData);

      return combineLatest([
        getVersionData(),
        getKnownIssues(),
        getFurtureFeatures()
      ]).pipe(
        map( ([versionData, knownIssuesData, futureFeaturesData]) => {
          if(!versionData || !knownIssuesData || !futureFeaturesData) {
            return storedData;
          }
          versionStoredData.versionData = this.updateList(versionStoredData.versionData, versionData);
          versionStoredData.knownIssues = this.updateList(versionStoredData.knownIssues, knownIssuesData);
          versionStoredData.futureFeatures = this.updateList(versionStoredData.futureFeatures, futureFeaturesData);
          console.log("%cVersion Data updated successfully", "color: lightgreen");
          localStorage.setItem('logbook.version.data', JSON.stringify(versionStoredData));
          return versionStoredData;
        })
      )
    }
    return EMPTY;
  }

  updateList(storedList: any[], newList: any[]): any[] {
    if(storedList){
      const updatedList = storedList.filter( (item) => newList.some( (newItem) => item.id === newItem.id));
      newList.forEach( (newItem) => {
        if (!updatedList.some( (item) => item.id === newItem.id)) {
          updatedList.push(newItem);
        }
      });
      return updatedList;
    }
    else {
      return [];
    }
  }

  // loadInitalVersionData(): Observable<any> {
  //     return this.http.get('./assets/data/version-details.json').pipe(
  //       map((versionData) => {
  //         if(!versionData) {
  //           return EMPTY;
  //         }
  //         return versionData;
  //       })
  //     )
  // }

  // loadInitialKnownIssuesData(): Observable<any> {
  //     return this.http.get('./assets/data/known-issues.json').pipe(
  //       map((knownIssuesData) => {
  //         if(!knownIssuesData) {
  //           return EMPTY;
  //         }
  //         return knownIssuesData;
  //       })
  //     );
  // }

  // loadInitialFutureFeaturesData(): Observable<any> {
  //   return of(knownIssues());
    // return this.http.get('./assets/data/future-features.json').pipe(
    //   map((futureFeaturesData) => {
    //     if(!futureFeaturesData) {
    //       return EMPTY;
    //     }
    //     return futureFeaturesData;
    //   })
    // );
  // }

  getAboutBadgeValue(): string {
    const aboutData = JSON.parse(localStorage.getItem('logbook.version.data') || '{}');
    let badgeValue = 0;
    if (aboutData) {
      if (aboutData.futureFeatures) {
        aboutData.futureFeatures.forEach((feature: any) => {
          if (feature.isNew) {
            badgeValue++;
          }
        });
      }
      if (aboutData.knownIssues) {
        aboutData.knownIssues.forEach((issue: any) => {
          if (issue.isNew) {
            badgeValue++;
          }
        });
      }
      if (aboutData.versionData) {
        aboutData.versionData.forEach((detail: any) => {
          if (detail.isNew) {
            badgeValue++;
          }
        });
      }
      if (badgeValue > 0) {
        this.navSignalsService.badgeCountActive$.set(true);
      }
      else {
        this.navSignalsService.badgeCountActive$.set(false);
      }
    }
    return badgeValue.toString();
  }
}



